import { useEffect } from "react";

import config from "./config";
import { Tester } from "generated/graphql";

const token = config.token;

const runScript = (tester: Tester) => {
  const setupScript = document.createElement("script");
  const signUpDate = Date.parse(tester.createdAt) / 1000;

  setupScript.type = "text/javascript";
  setupScript.async = true;
  setupScript.innerHTML = `
      window.wootricSettings = {
        email: "${tester.email}",
        created_at: "${signUpDate}",
        account_token: "${token}"
      };
    `;
  document.body.appendChild(setupScript);

  //Beacon
  const beacon = document.createElement("script");

  beacon.type = "text/javascript";
  beacon.async = true;

  beacon.src = "https://disutgh7q0ncc.cloudfront.net/beacon.js";
  beacon.onload = function () {
    try {
      if (window.wootric) {
        window.wootric("run");
        console.info("Wootric loaded");
      }
    } catch (error) {
      console.error(error);
    }
  };
  document.body.appendChild(beacon);
};

const Wootric = ({ currentTester }: { currentTester: Tester }) => {
  useEffect(() => {
    if (token) runScript(currentTester);

    return () => {
      try {
        if (window.WootricSurvey) {
          window.WootricSurvey.stop();
        }
      } catch (error) {
        console.error(error);
      }
    };
  }, []);

  return null;
};

export default Wootric;
